import { Spinner } from '@talentmesh/ui/components/spinner';
import { useMemo } from 'react';
import { useReadLocalStorage } from 'usehooks-ts';
import useAISearchProgress from '../../../api/useAISearchProgress';
import { disableAutoOpenRefineSearchDialogKey } from '../RefineSearch/RefineSearchButton';
import MatchingProgress, { Step } from './MatchingProgress';
import UIStrings from '@/Utils/UIStrings';

const IdentifiedPageLoadingAnimation = () => {
    const { data, isLoading } = useAISearchProgress();
    const hasOpenedIdentifiedListMap = useReadLocalStorage<Map<string, boolean>>(disableAutoOpenRefineSearchDialogKey, {
        deserializer: (state) => {
            try {
                return new Map(JSON.parse(state!));
            } catch {
                return new Map();
            }
        },
    });
    const steps: Step[] = useMemo(() => {
        const value = [
            {
                title: UIStrings.CandidateDiscovery,
                substeps: [{ duration: 5, title: UIStrings.MatchingCandidatesFromDatabase }],
            },
            {
                title: UIStrings.CandidateRanking,
                substeps: [{ duration: 10, title: UIStrings.RankingCandidatesBasedOnRelevanceAndFit }],
            },
        ];

        value[0].substeps.forEach((step) => (step.duration = 0));

        return value;
    }, [hasOpenedIdentifiedListMap, data]);

    return (
        <div data-cy="TMWingsLoading" className="flex flex-1 flex-col items-center justify-center bg-white">
            {isLoading ? <Spinner className="text-primary size-10" /> : <MatchingProgress steps={steps} />}
        </div>
    );
};

export default IdentifiedPageLoadingAnimation;
